import * as React from "react";
import { UserLotteryView } from "../../components";
import { Socket } from "socket.io-client";

const UserTickets: React.FC<{}> = () => {
    return (
        <UserLotteryView />
    );
};

export default UserTickets;
